import React from 'react';

const PickupLocationIcon = () => (
  <svg
    width="58"
    height="48"
    viewBox="0 0 58 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M28.6673 0C20.9221 0 14.6434 6.27871 14.6434 14.0239C14.5471 16.9135 16.9339 25.1162 26.9436 35.7248C27.8945 36.7326 29.4759 36.7829 30.459 35.8065C35.3833 30.9155 42.6912 21.7866 42.6912 14.0239C42.6912 6.27871 36.4125 0 28.6673 0Z"
      fill="#006AAC"
    />
    <circle cx="28.9722" cy="14.3276" r="5.79248" fill="white" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.7777 24.5947C17.2193 29.1662 21.0648 34.7178 26.9324 40.8976C27.8906 41.9068 29.4823 41.9566 30.476 40.9824C34.3576 37.1765 39.5974 31.0894 42.975 24.5947H47.087C48.1709 24.5947 49.1423 25.2635 49.5292 26.2759L55.9893 43.1822C56.6433 44.8938 55.3794 46.7298 53.5471 46.7298H3.12406C1.35439 46.7298 0.0959864 45.0084 0.632934 43.3221L6.01637 26.4159C6.36174 25.3312 7.36921 24.5947 8.5075 24.5947H14.7777Z"
      fill="#006AAC"
    />
  </svg>
);

export default PickupLocationIcon;
